export default "__VITE_ASSET__DZVYUIoe__"